<template>
  <div
    class="grid-stack-item"
    :class="computedClass"
    :id="`${widget.id}`"
    :ref="widget.id"
    :gs-id="widget.id"
    :gs-x="widget.x"
    :gs-y="widget.y"
    :gs-w="widget.w"
    :gs-min-w="widget.minW ? widget.minW : 0"
    :gs-min-h="widget.minH ? widget.minH : 0"
    :gs-h="widget.h"
    :gs-no-resize="widget.noResize"
    :gs-no-move="widget.noMove"
    :gs-locked="computedLocked"
  >
    <div :class="['grid-stack-item-content', { locked: computedLocked }]">
      <AppPreviewWidget
        v-if="showWidget(['costs', 'hours', 'trips', 'invoices'])"
        :widget="widget"
        @widget-event="processWidgetEvent"
        @save-config="saveWidgetConfig"
      />
      <CashflowWidget
        v-if="showWidget(['cashflow-chart'])"
        :widget="widget"
        @widget-event="processWidgetEvent"
        @save-config="saveWidgetConfig"
      />
      <TimelineWidget
        v-if="showWidget(['activities-timeline'])"
        :widget="widget"
        @widget-event="processWidgetEvent"
        @save-config="saveWidgetConfig"
      />
      <!-- <NotificationsWidget 
        v-if="showWidget(['notifications'])"
        :widget="widget" @widget-event="processWidgetEvent" @save-config="saveWidgetConfig"
      /> -->
      <RaboFinanceWidget
        v-if="showWidget(['rabo-finance'])"
        :widget="widget"
        @widget-event="processWidgetEvent"
        @save-config="saveWidgetConfig"
      />
      <CompanyProfileWidget
        v-if="showWidget(['company-profile'])"
        :widget="widget"
        @widget-event="processWidgetEvent"
        @save-config="saveWidgetConfig"
      />
      <HeroesProgramWidget
        v-if="showWidget(['heroes-program'])"
        :widget="widget"
        @widget-event="processWidgetEvent"
        @save-config="saveWidgetConfig"
      />
      <PaymentsOverviewWidget
        v-if="showWidget(['payments-overview'])"
        :widget="widget"
        @widget-event="processWidgetEvent"
        @save-config="saveWidgetConfig"
      />
      <PreviousPaymentsWidget
        v-if="showWidget(['previous-payments-overview'])"
        :widget="widget"
        @widget-event="processWidgetEvent"
        @save-config="saveWidgetConfig"
      />
      <AccountantWidget
        v-if="showWidget(['accountant'])"
        :widget="widget"
        @widget-event="processWidgetEvent"
        @save-config="saveWidgetConfig"
      />
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import AppPreviewWidget from '@/components/dashboard/widgets/AppPreviewWidget'
import CashflowWidget from '@/components/dashboard/widgets/CashflowWidget'
import TimelineWidget from '@/components/dashboard/widgets/TimelineWidget'
// import NotificationsWidget from "@/components/dashboard/widgets/NotificationsWidget"
import CompanyProfileWidget from '@/components/dashboard/widgets/CompanyProfileWidget'
import HeroesProgramWidget from '@/components/dashboard/widgets/HeroesProgramWidget'
import PaymentsOverviewWidget from '@/components/dashboard/widgets/PaymentsOverviewWidget'
import PreviousPaymentsWidget from '@/components/dashboard/widgets/PreviousPaymentsWidget'
import AccountantWidget from '@/components/dashboard/widgets/AccountantWidget'
import RaboFinanceWidget from '@/components/dashboard/widgets/RaboFinanceWidget'

export default {
  name: 'GridContainerItem',
  components: {
    AppPreviewWidget,
    CashflowWidget,
    TimelineWidget,
    CompanyProfileWidget,
    PaymentsOverviewWidget,
    PreviousPaymentsWidget,
    AccountantWidget,
    HeroesProgramWidget,
    RaboFinanceWidget
  },
  props: {
    widget: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      widget_options: [],
      forceLocked: null,
    }
  },
  computed: {
    computedClass() {
      return this.widget.type === 'activities-timeline' ? 'activities-timeline-widget' : this.widget.type
    },
    computedLocked() {
      return this.forceLocked !== null ? this.forceLocked : this.widget.locked
    },
  },
  mounted() {
    this.$emit('init-gridstack-widget', this.$el)
  },
  methods: {
    ...mapMutations({ updateWidgetConfig: 'dashboard/UPDATE_WIDGET_CONFIG' }),
    processWidgetEvent(data) {
      switch (data.event) {
        case 'remove':
          this.$emit('remove-gridstack-widget', this.$el)
          break
        case 'update':
          // this.$emit("update-gridstack-widget", { class: data.target, params: { y: 0 } })
          break
        case 'refresh':
          break
      }
    },
    saveWidgetConfig(config) {
      this.updateWidgetConfig({ id: this.widget.id, config: config })
      this.$emit('updated-widget-settings') // emit custom update event to refresh cookies data
    },
    showWidget(widget_name) {
      return Array.isArray(widget_name) ? widget_name.includes(this.widget.type) : this.widget.type === widget_name
    },
  },
}
</script>

<style lang="scss" scoped>
.os-host {
  height: 100%;
}
</style>

<style lang="scss">
.grid-stack-item {
  .ui-resizable-se {
    opacity: 0.5;
    bottom: 15px !important;
    right: 15px !important;
    transition: opacity 0.2s ease;
    &:hover {
      opacity: 1;
    }
  }
  .grid-stack-item-content {
    // &.locked { outline: 2px solid red; }
    box-shadow: $contentShadow;
  }
  &:hover {
    .ui-widget-menu-dropdown {
      opacity: 1;
    }
    .grid-stack-item-content {
      .widget-wrapper {
        border-color: $colorBrand;
        .content-wrap {
          .header {
            &.has-header {
              // background-color: rgba(34, 172, 138, 0.05);
            }
          }
        }
      }
    }
  }
}
.grid-stack-item-content {
  background: #ffffff;
  $shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  // box-shadow: 0 0 #0000, 0 0 #0000, $shadow;
  inset: $gridHalfGutter !important;
  border-radius: $gridBorderRadius;
  .widget-wrapper {
    height: 100%;
    width: 100%;
    transition: border-color 0.2s ease;
    border-radius: $gridBorderRadius;
    border: 1px solid $colorBorderDash;
  }
}
.grid-stack > .grid-stack-item > .grid-stack-item-content {
  overflow: visible !important;
}
.dashboard-tooltip {
  font-size: 12px !important;
  &.bs-tooltip-left {
    .arrow {
      &:before {
        border-left-color: #2a2a2f !important;
      }
    }
  }
  .tooltip-inner {
    background: #2a2a2f !important;
  }
}
</style>